import { render, staticRenderFns } from "./ImagenCompresionPrueba.vue?vue&type=template&id=40ecbbbe&scoped=true"
import script from "./ImagenCompresionPrueba.vue?vue&type=script&setup=true&lang=js"
export * from "./ImagenCompresionPrueba.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ImagenCompresionPrueba.vue?vue&type=style&index=0&id=40ecbbbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ecbbbe",
  null
  
)

export default component.exports